/**
 * 移入 / 移出执行结果上方的提示：
 * - 包牌已在目标批次（`ALREADY_IN_BATCH`）的行按目标批次聚合成一条「包牌1、包牌2已在该批次」（Q9）
 * - 有异步受理（ASYNC）的成功行时提示「批次记录已更新，包裹轨迹稍后可见」（Q12）
 */
import { Alert } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { MoveResultRowApi } from '../graphql/mutations/sortingBatchMove';

export interface MoveResultNoticesProps {
    rows: MoveResultRowApi[];
    /** 取该行的目标批次名（移入时为仓管所选批次） */
    targetBatchOf?: (row: MoveResultRowApi) => string | undefined;
}

export const MoveResultNotices: React.FC<MoveResultNoticesProps> = ({ rows, targetBatchOf }) => {
    const { t } = useTranslation();
    const separator = String(t('wms.sortingBatch.common.separator'));

    const alreadyIn = new Map<string, string[]>();
    rows.filter((r) => r.resultCode === 'ALREADY_IN_BATCH').forEach((r) => {
        const batch = targetBatchOf?.(r) ?? r.batchName ?? '';
        alreadyIn.set(batch, [...(alreadyIn.get(batch) || []), r.bagNumber ?? r.number]);
    });
    const hasAsync = rows.some((r) => r.success && r.executionMode === 'ASYNC');

    if (!alreadyIn.size && !hasAsync) return null;
    return (
        <div className="flex flex-col gap-2">
            {Array.from(alreadyIn.entries()).map(([batch, bags]) => (
                <Alert
                    key={`already-${batch}`}
                    type="warning"
                    showIcon
                    message={<span>{t('wms.sortingBatch.moveIn.alreadyInBatchSummary', { bags: bags.join(separator), batch })}</span>}
                />
            ))}
            {hasAsync ? <Alert type="info" showIcon message={<span>{t('wms.sortingBatch.moveIn.asyncHint')}</span>} /> : null}
        </div>
    );
};
